import { Component } from '@angular/core';
import {faBroadcastTower} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'morse-code-generator';
  tower = faBroadcastTower;
}
